import { useContext } from 'react';
import { useQuery } from 'react-query';
import {
  applicationLoanRequestKeys,
  parseApplicationLoanRequestKey,
} from '../cache-keys/applicationLoanRequestKeys';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { loan_request_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

export function useLoanRequest({
  loanApplicationID,
  loanRequestID,
}: {
  loanApplicationID: string;
  loanRequestID: string | undefined;
}) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = applicationLoanRequestKeys.root({
    applicationID: loanApplicationID,
    requestID: loanRequestID ?? '',
  });
  return useQuery(
    cacheKey,
    queryFunction(
      loan_request_api.get(api),
      ({ queryKey }) => parseApplicationLoanRequestKey(queryKey).requestID
    ),
    {
      enabled: state.user.token.length > 0 && !!loanRequestID,
    }
  );
}
